$(->
  # TEAM TAB

  ## Benchmark checkboxes: ensure only 3 are checked, update employees
  $('#js-employee-index .is_benchmark').change(->
    if $(this).hasClass('limit') && $(this).is(':checked') && $('#js-employee-index .is_benchmark.limit:checked').length > 3
      if $('#js-employee-index .is_benchmark.limit:checked').last().attr('id') == $(this).attr('id')
        $('#js-employee-index .is_benchmark.limit:checked').first().prop('checked', false)
      else
        $('#js-employee-index .is_benchmark.limit:checked').last().prop('checked', false)

    $.post('/manage/employees/update_all', $('#js-employee-index .is_benchmark').serialize())
  )


  # EDIT EMPLOYEE -> EMPLOYEE MANAGEMENT TAB
  
  ## TODO: 8/9/17 - brittany@careerplug.com - The show/hide functionality for reason for leaving/employment ended at is broken.  The toggle is adding and removing a display: block style attr but the hidden class on the div remains.  The modal functionality works.
  ## Employment status dropdown
  $(document).on 'change', '#app_employment_status', (ev)->
    if $(this).val() == "1"
      $('#app_reason_for_leaving_input').show()
      $('#app_employment_ended_at_input').show()
    else
      $('#app_reason_for_leaving_input').hide()
      $('#app_employment_ended_at_input').hide()
    if $(this).val() == "2"
      m = window.get_modal_markup()
      m.html(window.get_modal_content('Please Note', '<p>After saving, this person will be moved to the Inactive section of Applicants.</p>', '<button type="button" class="btn btn-primary" data-dismiss="modal">OK</button>'))
      m.modal()

  $(document).on 'change', '.employee_question_set_value', (ev)->
    $(this).parent().find('a.update_employee_question_set').show()

  $(document).on 'click', 'a.update_employee_question_set', (ev)->
    ev.preventDefault()
    $(this).data('orig-text', $(this).html())
    the_link = $(this)
    $.ajax('/manage/employees/' + $(this).data('employee') + '/question_sets/' + $(this).parent().find('select').val(), {
      type: 'PATCH',
      dataType: 'json',
      complete: (jqXHR, textStatus)->
        the_link.html('Done')
        setTimeout(->
          the_link.html(the_link.data('orig-text')).hide()
        , 5000)
    })
    return false

  $(document).on 'click', 'a.edit_question_set', (ev)->
    ev.preventDefault()
    window.location.assign($(this).data('url').replace('_id_', $(this).parent().find('select').val()))
    return false

)
